import { SearchTarget } from '@woolworthsnz/styleguide';

export const NO_BOUGHT_BEFORE_ITEM_POSITION = 0;
export const MAX_BOUGHT_BEFORE_ITEM_POSITION = 6;
export const ALLOW_BOUGHT_BEFORE_ITEM_PAGES = [SearchTarget.Search, SearchTarget.Browse];
